module.exports = __webpack_public_path__ + "static/img/about.52c70c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about.png
// module id = FhzR
// module chunks = 0